import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	content: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		margin: 0,
		maxWidth: 280,
		textAlign: 'left',
	},
	link: {
		color: THEME.colors.primary.main,
	},
	labelWithHelp: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: SPACE[4],
	},
});
